// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","507":"e4820f30","523":"1ffe7e97","524":"371d28f7","573":"38cce509","933":"f1705488"}[chunkId] + ".chunk.js";
};